import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import AuthCard from './AuthCard';
import AuthInput from './AuthInput';
import AuthButton from './AuthButton';
import SocialLoginButton from './SocialLoginButton';
import { toast } from 'sonner';
import Logo from "../../assets/images/logo.png"

const Register = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    password: ''
  });
  
  const [agreeToTerms, setAgreeToTerms] = useState(false);
  
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };
  
  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (!agreeToTerms) {
      toast.error("You must agree to the terms and conditions");
      return;
    }
    
    // This would be connected to a real auth system in a production app
    console.log('Register attempt:', formData);
    
    // For demo purposes, show success message
    toast.success("Registration successful!");
  };
  
  const handleSocialRegister = (provider) => {
    console.log(`Register with ${provider}`);
    toast.info(`${provider} registration would happen here`);
  };
  
  return (
    <AuthCard 
      logo={Logo}
      title="Regjistrohu"
      subtitle="Krijo llogarine tende"
    >
      <form onSubmit={handleSubmit}>
        <AuthInput 
          label="Name" 
          type="text" 
          name="name"
          placeholder="John Doe" 
          value={formData.name}
          onChange={handleChange}
          required
        />
        
        <AuthInput 
          label="Email" 
          type="email" 
          name="email"
          placeholder="email@example.com" 
          value={formData.email}
          onChange={handleChange}
          required
        />
        
        <AuthInput 
          label="Password" 
          type="password" 
          name="password"
          placeholder="Create a strong password" 
          value={formData.password}
          onChange={handleChange}
          required
        />
        
        <div className="flex items-center mb-6">
          <input
            id="terms"
            name="terms"
            type="checkbox"
            checked={agreeToTerms}
            onChange={() => setAgreeToTerms(!agreeToTerms)}
            className="h-4 w-4 text-red-600 focus:ring-red-500 border-gray-300 rounded"
          />
          
          <label htmlFor="terms" className="ml-2 block text-sm text-gray-700">
          Duke regjistruar një llogari, ju pranoni Termet dhe kushtet dhe Politika e privatësisë*
          </label>
        </div>
        
        <div className="mb-6">
          <AuthButton type="submit" variant="primary">
          Vazhdoni
          </AuthButton>
        </div>
      </form>
      
      <div className="relative mb-6">
        <div className="absolute inset-0 flex items-center">
          <div className="w-full border-t border-gray-300"></div>
        </div>
        <div className="relative flex justify-center text-sm">
          <span className="px-2 bg-white text-gray-500">or</span>
        </div>
      </div>
      
      <div className="space-y-3 mb-6">
        <SocialLoginButton provider="google" onClick={() => handleSocialRegister('Google')} />
        <SocialLoginButton provider="facebook" onClick={() => handleSocialRegister('Facebook')} />
      </div>
      
      <p className="text-center text-sm text-gray-600">
      Posedoni një llogari?{' '}
        <Link to="/login" className="font-medium text-red-600 hover:text-red-500">
        Kyçuni
        </Link>
      </p>
    </AuthCard>
  );
};

export default Register;